export default __webpack_public_path__ + "DGR_logo_ikon_neg.png";